import { Modal, Select, Tag } from 'antd';
import useModal from 'hooks/useModal';
import SelectContent from './SelectContent';
import { useEffect, useState } from 'react';
import { useTranslate } from '@tolgee/react';
import { css } from '@emotion/css';

function ItemSelect({
  filter,
  value,
  onChange,
}: {
  filter: Omit<ReviewAnalysis.OverviewFilter, 'spuIds'>;
  value: string[];
  onChange: (value: string[]) => void;
}) {
  const { t } = useTranslate();

  const { visible, show, hide } = useModal();

  const [_value, setValue] = useState(value);
  useEffect(() => {
    setValue(value);
  }, [value]);

  const select = (
    <Select
      className={cls}
      showSearch={false}
      mode="multiple"
      placeholder={t('选择商品')}
      open={false}
      value={value}
      onClick={show}
      tagRender={({ value: cur }) => {
        if (cur === value[0]) {
          return (
            <Tag
              closable
              onClose={() => {
                onChange([]);
                setValue([]);
              }}
            >
              {t('aide.已选x项', { x: value.length })}
            </Tag>
          );
        }
        return <></>;
      }}
    />
  );

  const modal = (
    <Modal
      closable={false}
      width={1200}
      visible={visible}
      onCancel={hide}
      okText={t('department.确认选择')}
      onOk={() => {
        onChange(_value);
        hide();
      }}
    >
      <div className="m-[-24px]">
        <SelectContent filter={filter} value={_value} onChange={setValue} />
      </div>
    </Modal>
  );

  return (
    <>
      {select}
      {modal}
    </>
  );
}

const cls = css`
  min-width: 110px;
  .ant-select-selection-overflow-item-suffix {
    display: none;
  }
`;

export default ItemSelect;
